module.exports = __webpack_public_path__ + "img/win_icon.f1ee19c8.svg";